import {config} from "@/config/config.ts";
import LandingNav from "@/landing/components/LandingNav.tsx";
import ArrowUpRightIcon from "@/landing/icons/ArrowUpRightIcon.tsx";
import FooterSection from "@/landing/sections/FooterSection.tsx";
import HeroSection from "@/pages/sales/HeroSection.tsx";
import ItWorksSection from "@/pages/sales/ItWorksSection.tsx";
import StillDoingThisManuallySection from "@/pages/sales/StillDoingThisManuallySection.tsx";
import TestimonialSection from "@/pages/sales/TestimonialSection.tsx";
import TheSimpleUpgradeSection from "@/pages/sales/TheSimpleUpgradeSection.tsx";
import TryItFreeSection from "@/pages/sales/TryItFreeSection.tsx";
import WhatOrganizersAreSayingSection from "@/pages/sales/WhatOrganizersAreSayingSection.tsx";
import WhatPlayersExperienceSection from "@/pages/sales/WhatPlayersExperienceSection.tsx";
import WhoIsItForSection from "@/pages/sales/WhoIsItForSection.tsx";
import WhyPeopleSwitchSection from "@/pages/sales/WhyPeopleSwitchSection.tsx";
import {createFileRoute, Link} from '@tanstack/react-router'
import ctaBg from '@/landing/assets/about_us_4.webp';
import screenshots from '@/landing/assets/sales/screenshots.png';
import heroBg from '@/landing/assets/sales/hero_bg.webp';
import heroMobileBg from '@/landing/assets/sales/hero_mobile_bg.webp';
import pricingPattern1 from '@/landing/assets/pricing_pattern_1.webp';
import pricingPattern2 from '@/landing/assets/pricing_pattern_2.webp';

export const Route = createFileRoute('/sales')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <div className="min-h-screen bg-[#EDEEF4]">
            <title>Tournament & League Management Software | Sports Tournament Software - ScorePal</title>
            <meta name="description" content="Manage your tournaments and leagues effortlessly with ScorePal – an all-in-one sports management software. Automate scheduling, scoring, and results tracking in real time." />
            <link rel="canonical" href={`${config.publicUrl}/sales/`} />

            <HeroSection />

            <div className={"-mt-32 z-10 relative"}>
                <img src={screenshots} alt={"ScorePal screenshots"} />
            </div>

            <TestimonialSection />
            <WhoIsItForSection />
            <StillDoingThisManuallySection />
            <TheSimpleUpgradeSection />
            <WhyPeopleSwitchSection />
            <ItWorksSection />
            <WhatPlayersExperienceSection />
            <WhatOrganizersAreSayingSection />
            <TryItFreeSection />

            <FooterSection />
        </div>
    );
}
